__turbopack_context__.v({
  "bottom": "form-module-scss-module__kMWajq__bottom",
  "filters": "form-module-scss-module__kMWajq__filters",
  "form": "form-module-scss-module__kMWajq__form",
  "job": "form-module-scss-module__kMWajq__job",
  "location": "form-module-scss-module__kMWajq__location",
  "typeaheads": "form-module-scss-module__kMWajq__typeaheads",
});
